<article class="product-card" *ngIf="sku as s">
  <div class="product-card__media" (click)="openPopup()">
    <img class="product-card__image" [src]="s.images | getImagePathByType:'THUMBNAIL'" [alt]="s.productSkuEavs | getValueByAttribute:'name':'value'">
    <div *ngIf="badge" class="product-card__ribbon" aria-hidden="true">
      <span class="product-card__ribbon-text">{{ badge }}</span>
    </div>
  </div>

  <div class="product-card__body">
    <h4 class="product-card__name font-display">
      <span class="product-card__name-zh">{{ displayName }}</span>
      <span class="product-card__name-en" *ngIf="displaySubName">{{ displaySubName }}</span>
    </h4>
    <p class="product-card__price font-mono" i18n="@@product.pricePrefix">HK$ {{ isSalesPrice() ? (s | getProductSalesPriceIfAny) : s.price }}</p>

    <div class="product-card__actions">
      <div class="product-card__qty">
        <button type="button" i18n-aria-label="@@product.qty.decrease.aria" aria-label="Decrease" (click)="decrementQty()">−</button>
        <span>{{ quantity }}</span>
        <button type="button" i18n-aria-label="@@product.qty.increase.aria" aria-label="Increase" (click)="incrementQty()">+</button>
      </div>
      <button type="button" class="product-card__add" (click)="addToCart()" [disabled]="isOutOfStock()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
        <ng-container *ngIf="isOutOfStock(); else inStock" i18n="@@product.outOfStock">暫時缺貨</ng-container>
        <ng-template #inStock i18n="@@product.addToCart">加入購物車</ng-template>
      </button>
    </div>
  </div>
</article>
